<template>
	<div :class="[isLargeScreen?'loginYy':'loginYyMobile']">
   <div class="nav">
     <div class="nav-inner-pannel">
      <div class="logo">
        <img src="../assets/images/common/logo.png" alt="全球贸易服务平台">
      </div>
      <div class="back-home"><router-link to="/">首页</router-link></div>
     </div>
   </div>
   <div class="main">
     <div class="form-wrap" :style="{'margin-top':marT+'vw'}">
        <div class="form-panel" v-if="loginWay=='0'">
          <div class="login-way-tab">
            <div class="current-tit">全球商通中心运营支撑体系</div>
            <div class="current-title">运营人员登录</div>
          </div>
          <el-form :model="userPsdForm" ref="ruleFormRef" :rules="rules">
            <el-form-item prop="usernameYy">
              <div class="zdy-label" v-if="isLargeScreen">
                <div class="zdy-label-inner">用户名</div>
              </div>
              <el-input
                v-model="userPsdForm.usernameYy"
                placeholder="请输入用户名"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="passwordYy">
              <div class="zdy-label" v-if="isLargeScreen">
                <div class="zdy-label-inner">登录密码</div>
              </div>
              <el-input
                v-model="userPsdForm.passwordYy"
                placeholder="请输入登录密码"
                type="password"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-button
              type="primary"
              class="login-sub-btn"
              :loading="loading"
              @click="submitForm(ruleFormRef)"
              ><span>登录</span></el-button
            >
          </el-form>
        </div>
      </div>
   </div>
   <div class="footer" ref="footerRef">
     <div class="footer-inner-pannel">
       <!-- <div><span>鲁ICP备2024099623号</span><span>公安备案</span><span>增值电信业务经营许可证</span><span>营业执照</span><span>食品经营许可证</span></div>
       <div><span>潍坊农业开发发展集团有限公司(版权所有)</span><span>齐民商通科技服务有限公司(运营公司)</span><span>北京新盟风控科技有限公司(技术公司)</span><span>客服电话：0536-7267526</span></div>
       <div class="float-r"><span>法律声明</span><span>隐私政策声明</span></div> -->
       <Footer :platInfo="platInfo"></Footer>
     </div>
   </div>
   
  </div>
</template>
<script setup>
import { getCurrentInstance, reactive, ref,onMounted,computed,onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Md5 from "js-md5";
import Footer from '../components/footerZz.vue'
let Base64 = require("js-base64").Base64;
const { proxy } = getCurrentInstance();
const props = defineProps({
    platInfo: {
        type: Object,
        default: {}
    }
})
const router = useRouter();
const route=useRoute();
let userPsdForm=reactive({});
let rules = reactive({
  usernameYy: [{ required: true, message:"请输入用户名", trigger: "blur" }],
  passwordYy: [{ required: true, message:"请输入登录密码", trigger: "blur" }],
});
let loginWay=ref("0")
let mobileCodeForm=reactive({});
let mobileCodeRules=reactive({
  mobile: [
    { required: true, message:"请输入手机号或邮箱", trigger: "blur" },
  ],
  valCode: [{ required: true, message:"请输入验证码", trigger: "blur" }],
})

let loading=ref(false);
const ruleFormRef=ref();
const mobileCodeRef=ref();
function submitForm(formEl){
  formEl.validate((valid) => {
    if (!valid) return false;
    loading.value = true;
    if (loginWay.value == "0") {
      userPsdLogin();
    } else {
      mobileCodeLogin();
    }
  });
}
function getQueryParam(param) {//获取地址拦指定参数值
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}
function removeUrlParam(url, param) {
  // 分割 URL 为基础部分和参数部分
  const [base, query] = url.split('?');
  if (!query) return url; // 没有参数则直接返回原 URL
  
  // 分割参数并过滤掉要移除的参数
  const params = query.split('&').filter(item => !item.startsWith(`${param}=`));
  
  // 重新拼接 URL（如果还有剩余参数则保留问号，否则去掉）
  return params.length > 0 ? `${base}?${params.join('&')}` : base;
}
//存储
function setLocalStorageWithExpiry(key, value) {
  const now = new Date().getTime();
  // 数据结构：{ value: 存储值, expiry: 过期时间戳 }
  const item = {
    value: value,
    expiry: now + 60 * 1000 *60 *2 // 1分钟后过期（60秒 * 1000毫秒）
  };
  localStorage.setItem(key, JSON.stringify(item));
}
// 读取有效期内的用户名
function getExpiringUsername(key) {
  const storedData = localStorage.getItem(key);
  
  if (!storedData) return null;
  
  const { value, expiry } = JSON.parse(storedData);
  const now = Date.now();
  
  // 检查是否过期
  if (now > expiry) {
    localStorage.removeItem(key); // 过期则删除
    return null;
  }
  
  return value; // 返回有效用户名
}
// 使用示例
function userPsdLogin(loginUrl) {
  var passwordYy ="",basic ="",loginUrl="MASTER_LOGIN";
  passwordYy = Md5(userPsdForm.passwordYy);
  basic = "Basic " + Base64.encode(userPsdForm.usernameYy + ":" + passwordYy);
  //运营账号校验
  if(basic=='Basic c3R6eHl5OmUxMGFkYzM5NDliYTU5YWJiZTU2ZTA1N2YyMGY4ODNl'){
    setLocalStorageWithExpiry("sznc_WebsiteUsername_yy", userPsdForm.usernameYy);
    if(getQueryParam("toPath")){
      // 动态创建 a 标签 
      const link = document.createElement('a');
      link.href = removeUrlParam(atob(getQueryParam("toPath")), 'loginType');  // 设置目标 URL 
      document.body.appendChild(link);
      link.click();
    }
  }else{
    proxy.$message.warning("运营账户不正确");
    loading.value = false
  }
}
function init() {
  if(getExpiringUsername("sznc_WebsiteUsername_yy")){
    router.push({
      path:'/'
    });
  }
}
// 1. 定义一个响应式变量来存储窗口宽度
const windowWidth = ref(window.innerWidth);

// 2. 定义一个方法来更新窗口宽度
const updateWidth = () => {
  windowWidth.value = window.innerWidth;
};

// 3. 使用 computed 属性来判断屏幕大小
//    这里以 768px 为分界线，你可以根据需求修改
const isLargeScreen = computed(() => {
  return windowWidth.value >= 768;
});
const footerRef=ref();
const marT=ref(0);
// 4. 组件挂载时：添加 resize 事件监听器
onMounted(() => {
  if(isLargeScreen.value){
    const footerH=footerRef.value.clientHeight;
    const footerHvw=(footerH/1920*100)/2
    marT.value=-(13+footerHvw);
  }
  
  window.addEventListener('resize', updateWidth);
});

// 5. 组件卸载时：移除 resize 事件监听器，防止内存泄漏
onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});
</script>

<style lang="less">
.loginYy{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;@font-face {
  font-family: 'iconfont';  /* Project id 5011108 */
    src: url('//at.alicdn.com/t/c/font_5011108_2meb2fzt51o.woff2?t=1756705900704') format('woff2'),
        url('//at.alicdn.com/t/c/font_5011108_2meb2fzt51o.woff?t=1756705900704') format('woff'),
        url('//at.alicdn.com/t/c/font_5011108_2meb2fzt51o.ttf?t=1756705900704') format('truetype');
  }
  position: relative;
  .iconfont{
    font-family: 'iconfont'; 
  }
  .nav{
    width: 100%;
    height: 3.91vw;
    background: #fff;
    .nav-inner-pannel{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1vw 1.56vw;
    }
    .logo{
      width: 10.89vw;
      img{
        width: 100%;
      }
    }
    a{
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.73vw;
      color: #222222;
      line-height: 1vw;
    }
  }
  .main{
    flex:1;
    min-height: 27vw;
    width: 100%;
    background: url(../assets/images/login_bg_yy.png) no-repeat top center;
    background-size: 100% auto;
    background-color: #D5E2F5;
    position: relative;
    .form-wrap{
      width: 24.756vw;
      height: 26.146vw;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -12.378vw;
      margin-top: -13vw;
      .form-panel{
        padding: 1.98vw 1.56vw 0;
        .login-way-tab{
          // display: flex;
          // justify-content: space-between;
          margin-bottom: 1.825vw;
          .current-tit{
            font-family: PingFangSC-Semibold;
            font-size: 1.35vw;
            color: #333333;
            line-height: 1.56vw;
          }
          .current-title{
            font-family: PingFangSC-Semibold;
            font-size: 1vw;
            color: #333333;
            margin-top: 0.8vw;
          }
          .btn-tit{
            font-family: PingFangSC-Semibold;
            font-size: 1.04vw;
            color: #2D87FE;
          }
        }
        .el-form{
          .zdy-label{
            width: 4.2vw;
            border: 1px solid #dcdfe6;
            border-right: 0;
            border-top-left-radius: 2px;
            border-bottom-left-radius: 2px;
            .zdy-label-inner{
              height: 2.7vw;
              line-height: 2.7vw;
              font-size: 0.833vw;
              font-weight: 500;
              text-align: center;
              color: #333333;
            }
          }
          .el-form-item{
            margin-bottom: 0.9375vw;
          }
          .el-form-item__error{
            font-size: 0.75vw;
          }
          .el-input__wrapper{
            border-radius: 2px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
          .el-input{
            flex: 1;
            .el-input__inner{
              height: 2.7vw;
              font-size:0.75vw;
            }
          }
          .val-code-wrap{
            display: flex;
            width: 100%;
            .el-button{
              width: 8.33vw;
              height: 2.7vw;
              line-height: 2.7vw;
              background-color: #2D87FE;
              font-size:0.75vw;
            }
          }
          .login-sub-btn{
            width: 100%;
            height: 2.813vw;
            margin-top: 2.4vw;
            margin-bottom: 1.146vw;
            background-color: #2D87FE;
            font-size: 0.83vw;
          }
        }
        .remeber-passwordYy{
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.833vw;
          .el-checkbox.el-checkbox--small{
            height: 0.9375vw;
          }
          .el-checkbox.el-checkbox--small .el-checkbox__inner{
            width: 0.9375vw;
            height: 0.9375vw;
          }
          .el-checkbox.el-checkbox--small .el-checkbox__label{
            font-size: 0.73vw;
          }
          .el-checkbox__label{
            padding-left: 0.42vw;
          }
          a{
            font-family: PingFangSC-Semibold;
            color: #2D87FE;
            font-size: 0.833vw;
            text-decoration: underline;
          }
        }
      }
      .go-register-panel{
        width: 100%;
        height: 3.44vw;
        background-color: #F8F8F8;
        position: absolute;
        bottom: 0;
        div{
          padding: 0 1.56vw;
          line-height: 3.44vw;
          font-size: 0.73vw;
          a{
            color: #2D87FE;
          }
        }
      }
    }
  }
  .footer{
    position: absolute;
    bottom: 0;
    width: 100%;
    //height: 4.583vw;
    background: #fff;
    .footer-inner-pannel{
      padding: 1vw 1.56vw;
      position: relative;
    }
    // div{
    //   margin-bottom: 0.42vw;
    // }

    // div.float-r{
    //   position: absolute;
    //   right: 0;
    //   top: 1vw;
    // }
    span{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.73vw;
      color: #2E2F2F;
      line-height: 1vw;
      margin-right: 0.833vw;
    }
  }
}
.loginYyMobile{
  .nav,.footer{
    display: none;
  }
  .main{
    padding: 0 5.33vw;
  }
  .form-wrap{
    padding-top: 30.93vw;
    .form-panel{
      .login-way-tab{
        // display: flex;
        // justify-content: center;
        margin-bottom: 6.93vw;
        .current-tit{
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 5.33vw;
          font-weight: bold;
          div.txt{
            line-height: 6.4vw;
            margin-bottom:2.67vw;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 4.533vw;
            color: #3D7EFD;
          }
          div.line{
            width: 13.33vw;
            height: 1.1vw;
            background: #3D7EFD;
          }
        }
        .current-title{
          text-align: center;
        }
        a.btn-tit{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 3.73vw;
          color: #171717;
          line-height: 6.4vw;
        }
      }
      .el-form-item{
        margin-bottom: 4vw;
      }
      .el-form-item__error{
        font-size:3.733vw;
      }
      .el-input__wrapper{
        border-radius: 4px;
      }
      .el-input{
        width: 100%;
        .el-input__inner{
          height: 12.27vw;
          font-size:3.733vw;
        }
      }
    }
    .login-sub-btn{
      width: 100%;
      height: 12.27vw;
      background: #3D7EFD;
      border-radius: 4px;
      margin-top: 5.33vw;

      span{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 4.27vw;
        color: #FFFFFF;
      }
    }
    .remeber-password{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5.33vw;
      .el-checkbox.el-checkbox--small{
        height: 4.8vw;
      }
      .el-checkbox.el-checkbox--small .el-checkbox__inner{
        width: 4.8vw;
        height: 4.8vw;
      }
      .el-checkbox.el-checkbox--small .el-checkbox__label{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 3.733vw;
        color: #979DA5;
        line-height: 5.33vw;
      }
      .el-checkbox__label{
        padding-left: 2.4vw;
      }
    }
    .go-register-panel{
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 3.733vw;
      color: #222222;
      a{
        color: #1663FF;
      }
    }
    
    .val-code-wrap{
      position: relative;
      width: 100%;
      margin-bottom: 1.33vw;
      .el-input__inner{
        padding-right: 21.87vw;
      }
      .code-btn{
        position: absolute;
        right: 3.2vw;
        top:3.7vw;
        line-height: 5.33vw;
        cursor: pointer;
        span{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 3.733vw;
          color: #3D7EFD;
        }
      }
    }
  }
}
</style>